import gql from 'graphql-tag';

export const GET_WAITLIST_DATA = gql`
  query GetVnmWaitlistData($planId: Int!) {
    plan(id: $planId) {
      id
      vnmProductSubscription {
        id
        vnmSubscription {
          id
          mostRecentSubscriptionSubmission {
            calculatedAllocationKw
          }
          vnmSolarProject(nonCumulativeCalculatedFields: true) {
            id
            name
            startDate
            city
            acquisitionStatistics {
              estimatedHomesPowered
            }
            firstYearProductionEstimate
            image {
              thumbnail
            }
            utility {
              state {
                abbreviation
              }
            }
            mdIdentifier
          }
        }
      }
    }
  }
`;

export const getWaitlistDataMock = {
  plan: {
    __typename: 'Plan',
    id: 1,
    vnmProductSubscription: {
      id: 99,
      vnmSubscription: {
        id: 999,
        mostRecentSubscriptionSubmission: {
          calculatedAllocationKw: 2,
        },
        vnmSolarProject: {
          acquisitionStatistics: {
            estimatedHomesPowered: 300,
          },
          city: 'Sunnyside Uptown',
          firstYearProductionEstimate: 2000.0,
          id: 9999,
          image: {
            thumbnail: 'aws.sunnyside-up.com',
          },
          name: 'Sunnyside up',
          startDate: '2020-08-01',
          utility: {
            state: {
              abbreviation: 'AZ',
            },
          },
          mdIdentifier: null,
        },
      },
    },
  },
};
